import React, { Component } from 'react';
import { connect } from 'react-redux';
import Card from './Card.js';


class List extends Component {
  render() {
    let content;

    if (this.props.items.length === 0) {
      content = (
        <span>emptu</span>
      );
    } else {
      content = (
        this.props.items.map(item => (
          <Card key={item.id} data={item}/>
        ))
      );
    }

    return (
      <main className="App-list">
        {content}  
      </main>
    );
  }
}

const mapStateToProps = (state, props) => {
  return Object.assign({}, props, {
    items: state.searchResults
  });
};

export default connect(mapStateToProps)(List);


// WEBPACK FOOTER //
// ./src/List.js